import Splide from "@splidejs/splide"

type Blog = {
    name: string
    date: string
    facebook: string
    twitter: string
    pinterest: string
    img: string
    url: string
    desc: string
    cat: string
}

const blogSliders = {
  catSlider: document.getElementById("blogSlider") as HTMLElement,
  slidersWrap: document.getElementById("blogSliders") as HTMLElement,
  blogs: (window as any).blogList as Blog[],
  blogName: document.getElementById('blogName') as HTMLElement,
 
  init() {
    this.catSliderInit()
    this.setTabs()    
  },

  catSliderInit() {
    if (this.catSlider) {
      new Splide(this.catSlider, {   
        pagination: false,
        speed: 800,
        gap: "10px",
        autoWidth: true,
      }).mount()
    }
  },
  singleSlider() {
    new Splide(this.slidersWrap, {
      perPage: 3,   
      pagination: false,
      speed: 800,
      gap: "50px",
      breakpoints: {
        480: {
          perPage: 1,
          gap: "10px",
        },
      },
    }).mount()
  },
  setSliders(id: string) {   
    const blogs = this.blogs.filter(item => item.cat === id)   
    if(blogs.length){
      let html = `<div class="splide__track">
                        <div class="splide__list">`
      blogs.forEach((item) => {
        if(id === item.cat){
            html += this.singleHtml(item)
        }
      })
      html += `</div>
                </div>`
      this.slidersWrap.innerHTML = html
      this.singleSlider()  
    }
  },
  setTabs() {
    const tabs = document.querySelectorAll('.jsTab') as NodeListOf<HTMLElement>
    if(tabs.length){
        this.blogName.innerHTML = tabs[0].dataset.name as string      
        this.setSliders(tabs[0].dataset.id as string)
        tabs[0].classList.add('active')   
      
        tabs.forEach(item=>{
            item.addEventListener('click', ()=>{        
                tabs.forEach(item=> item.classList.remove('active'))
                item.classList.add('active')   
                this.blogName.innerText = item.dataset.name as string  
                this.setSliders(item.dataset.id as string)
            })
        })
    }

  },

  singleHtml(item: Blog) {
    return `
        <article class="blog-box jsBlogSingleSlid splide__slide" data-id="${item.cat}">
            <div class="blog-box__wrap">
                <div class="blog-box__img" style="background-image: url(${item.img});">
                    <div  class="blog-box__share-wrap">
                        <ul  class="blog-box__share" >
                            <p  class="blog-box__share-text">Share</p>
                            <li>
                                <a class="blog-box__link" href="${item.facebook}">
                                    <svg class="" target="_blank">
                                        <use xlink:href="#facebook-f-brands"></use>
                                    </svg>
                                </a>
                                </li>
                            <li>
                                <a class="blog-box__link" href="${item.twitter}">
                                    <svg class="" target="_blank">
                                        <use xlink:href="#twitter-brands"></use>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="blog-box__link" href="${item.pinterest}">
                                    <svg class="" target="_blank">
                                        <use xlink:href="#instagram-brands"></use>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
            
                </div>
                <div  class="blog-box__text">
                    <div  class="blog-box__text-wrap">
                        <div class="blog-box__text-head">
                            <a href="${item.url}" class="section-title ">${item.name}</a>                   
                            <p class="blog-box__date">${item.date}</p>                  
                        
                        </div>
                        <p class="main-text">${item.desc}</p>
                        <a href="${item.url}" class="read-more">Read More  
                            <svg>
                                <use xlink:href="#arrow-right-long-thin"></use>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </article>
    `
  },
}

export default blogSliders
